import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AddressService } from './address.service';
import { AuthService } from './auth.service';
import { BudgetService } from './budget.service';
import { ConfigService } from './config.service';
import { ContentService } from './content.service';
import { EntityService } from './entity.service';
import { ImageService } from './image.service';
import { NotificationService } from './notification.service';
import { OrderService } from './order.service';
import { ProductService } from './product.service';
import { ProfileService } from './profile.service';
import { SearchService } from './search.service';
import { SortService } from './sort.service';
import { TranslateService } from './translate.service';
import { LocalStorageService } from './local-storage.service';
import { DoaService } from './doa.service';
import { PaymentService } from './payments.service';
import {ModalService} from './modal.service';
import { ApiOrderService } from './api-order.service';
import { ApiProductService } from './api-product.service';
import { PageService } from './page.service';
import { GoogleAnalytics } from './google-analytics.service';
import {OrderItemService} from './order-item.service';
import {MobileCheckServiceService} from './mobile-check-service.service';
import {HelperService} from './helper.service';
import {ApiRecommendedProductsService} from './api-recommended-products.service';
import {RecommendedProductsService} from './recommended-products.service';
import {ApiPaymentMethodsService} from './api-payment-methods.service';
import {CurrencyService} from './currency.service';
import {MultiTenantService} from './multi-tenant.service';
import {RestrictedRouterGuardService} from './restricted-router.guard.service';
import {ClientCustomizationService} from './client-customization.service';
import {LiveUpdateService} from './live-update.service';
import { CustomNgbModal } from './custom-ngb-modal.service';
import {DiscountCodeService} from './discount-code.service';
import {ChiliGrafixService} from './chiligrafix.service';
import {ScriptService} from './script.service';
import { PnpBudgetService } from './pnp-budget.service';
import { EUDRService } from './eudr.service';
import {DistributionGroupService} from './distribution-group-service';
import {OneTrustService} from './one-trust.service';
import {RefinerService} from './refiner.service';
import {TelemetryService} from './telemetry.service';

@NgModule()
export class ServiceModule {
    static forRoot(): ModuleWithProviders<ServiceModule> {
    return {
        ngModule: ServiceModule,
        providers: [
            AddressService,
            AuthService,
            BudgetService,
            ConfigService,
            ContentService,
            EntityService,
            ImageService,
            NotificationService,
            OrderService,
            ProductService,
            ProfileService,
            SearchService,
            SortService,
            TranslateService,
            LocalStorageService,
            DoaService,
            PaymentService,
            ModalService,
            ApiOrderService,
            ApiProductService,
            PageService,
            GoogleAnalytics,
            OrderItemService,
            MobileCheckServiceService,
            HelperService,
            ApiRecommendedProductsService,
            RecommendedProductsService,
            ApiPaymentMethodsService,
            CurrencyService,
            RestrictedRouterGuardService,
            MultiTenantService,
            ClientCustomizationService,
            LiveUpdateService,
            DiscountCodeService,
            { 
                provide: NgbModal, 
                useClass: CustomNgbModal 
            },
            ChiliGrafixService,
            ScriptService,
            EUDRService,
            PnpBudgetService,
            DistributionGroupService,
            OneTrustService,
            RefinerService,
            TelemetryService
        ]
    };
    }
    constructor (@Optional() @SkipSelf() parentModule?: ServiceModule) {
        if (parentModule) {
            throw new Error(
                'ServiceModule is already loaded. Import it in the AppModule only');
        }
    }
}
